import React from 'react';
import { Filter, BooleanInput, RadioButtonGroupInput, FormDataConsumer, ImageField, ImageInput, required, Toolbar, 
	SaveButton, DateField, TabbedForm, FormTab, Edit, Create, List, Datagrid, TextField, TextInput, NumberInput, 
	FunctionField, ReferenceArrayInput, AutocompleteArrayInput, SelectInput, SelectArrayInput,
	AutocompleteInput, ReferenceInput, ArrayInput, SimpleFormIterator} from 'react-admin';
import { Link, Box } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
// The preview renderer is shared with the advertiser self-serve creative form
// (src/advertiser/creatives.js), so it lives in components/utils.js.
import { CreativePreviewContent } from './components/utils';

const specialCategories = require('./components/special_categories.json');
const ctypeChoices = [
	{ id: 'image', name: 'Image Upload' },
	{ id: 'html', name: 'HTML/Javascript' },
	{ id: 'url', name: 'Image URL' },
	{ id: 'video', name: 'Video' },
	{ id: 'vast', name: 'Video VAST' },
	{ id: 'native', name: 'Native' },
];
const adsizeChoices = [
	{ id: '300x250', name: '300x250' },
	{ id: '728x90' , name: '728x90' },
	{ id: '300x600', name: '300x600' },
	{ id: '160x600', name: '160x600' },
	{ id: '120x600', name: '120x600' },
	{ id: '970x90' , name: '970x90' },
	{ id: '970x66' , name: '970x66' },
	{ id: '970x250', name: '970x250' },
	{ id: '300x1050', name: '300x1050' },
	{ id: '336x280', name: '336x280' },
	{ id: '320x50' , name: '320x50' },
	{ id: '320x100', name: '320x100' },
	{ id: '300x50' , name: '300x50' },
];
const CreativeTitle = ({ record }) => {
	return <span>Creative {record ? `"${record.name}"` : ''}</span>;
};
const CreativeFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
				{/* <BooleanInput source="backfill" defaultValue='true' label="Backfill Creatives" style={{ color: 'white' }} resettable /> */}
        <BooleanInput source="owned" defaultValue='true' label="Owned By Me" style={{ color: 'white' }} resettable />
        <ReferenceArrayInput source="advertiser_id"
            reference="advertisers"
            basePath='advertisers'
            perPage={10}
            sort={{ field: 'name', order: 'ASC' }}
            filterToQuery={searchText => ({ search_name: searchText })}>
            <AutocompleteArrayInput label="Advertisers" optionText="name" optionValue="code" style={{ width: '90%' }} />
        </ReferenceArrayInput>
    </Filter>
);
export const CreativeList = (props) => (
	<List {...props} title="Creatives" perPage={25} bulkActionButtons={false}
	filters={<CreativeFilter {...props}/>} >
		<Datagrid rowClick="edit">
			<TextField source="code" label="ID" />
			<TextField source="name" label="Name" />
			<FunctionField render={record => `${record.width}x${record.height}`} label="Ad Size"/>
			<DateField source="updated_at" label="Update Date" />
			<DateField source="created_at" label="Creation Date" />
		</Datagrid>
	</List>
);
const CustomToolbar = props => (
	<Toolbar {...props}>
		{props?.role === 'admin' && <SaveButton /> }
		<br />
		<DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
		<TextField source="updated_name" label="" style={{ padding: '10px' }} />
	</Toolbar>
);
const validateHTML = (data) => {
	if (data && data.indexOf('"')>=0) return {message: 'Error: Double quote is not allowed in HTML Ad Markup field.'};
	return null;
}

export const CreativeEdit = ({ permissions, ...props }) => (
	<Edit title={<CreativeTitle />} {...props}>
		<TabbedForm toolbar={<CustomToolbar  {...props} {...permissions} />}>
		<FormTab label="Creative Settings">
			<TextField source="code" label="Creative ID" />
			<TextInput source="name" label="Creative Name" style={{ width: '400px' }} validate={required()} />

			<ReferenceInput label="Advertiser *"
					perPage={15}
					sort={{ field: 'name', order: 'ASC' }}
					filterToQuery={searchText => ({ search_name: searchText })}
					source="advertiser_id"
					reference="advertisers"
					basePath='advertisers' defaultValue={101} >
					<AutocompleteInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""}
					optionValue='code' validate={required()} />
			</ReferenceInput>

			{/* <SelectInput label="Ad Size" source="adsize" validate={required()} choices={adsizeChoices} /> */}

			<NumberInput source="width" label="Creative Width" style={{ width: '400px' }} validate={required()} />

			<NumberInput source="height" label="Creative Height" style={{ width: '400px' }} validate={required()} />

			<ReferenceArrayInput source="iab_categories"
							reference="iab_categories"
							basePath='iab_categories'
							perPage={200}
							sort={{ field: 'name', order: 'DESC' }}
							filterToQuery={searchText => ({ search_name: searchText })}>
							<AutocompleteArrayInput label="IAB Categories" optionText="name" style={{ width: '90%' }} />
			</ReferenceArrayInput>

			{/* <SelectArrayInput label="Special Categories" choices={specialCategories}
				source="special_ad_categories" style={{ width: '400px' }}
      />

			<BooleanInput source="backfill" label="Eligible for Backfill" resettable /> */}

			<FormDataConsumer>
			{({ formData }) => (formData && formData.backfill) &&
			<BooleanInput source="targeted" label="Creative Targeted" resettable />
			}
			</FormDataConsumer>

			<RadioButtonGroupInput style={{width: '100%'}} options={{row:true}} label="Creative Type" source="ctype" choices={ctypeChoices} />

			<hr style={{width: '100%'}}/><br/>

			<FormDataConsumer style={{width: '100%'}}>
			{({ formData }) => (formData && formData.ctype === 'video') &&
				<div style={{width: '100%'}}>
				For video creatives set the size to 1x1<br/>
				<TextInput source="video_url" label='Video file URL' style={{width: '30%'}}/>
				<br/>
				<TextInput source="video_click_url" type='url' label='Click Through URL *' style={{width: '50%'}}/>
				<br/>
				<NumberInput source="video_duration" label='Video duration in seconds. Keep it under 60...' style={{width: '30%'}}/>
				<br/>
				<SelectInput style={{width: '30%'}} label="Video Mime" source="video_mime"
					choices={[
						{ id: 'video/mp4', name: 'video/mp4' }
					]}
				/>
				<br/>
				<TextInput source="video_impression_tracker" label='Video Impression Tracker' style={{width: '30%'}}/>
				<div>Enable tracking of video events: Video Start, 25% Complete, 50% Complete, 75% Complete, 100% Complete.</div>
				<BooleanInput source="video_event_trackers_enabled" label='Enable Video Event Trackers' style={{width: '9%'}}
				helpText="Enable tracking of video events: Video Start, 25% Complete, 50% Complete, 75% Complete, 100% Complete."
				/>
				</div>
			}
			</FormDataConsumer>
			<FormDataConsumer style={{width: '100%'}}>
			{({ formData }) => (formData && formData.ctype === 'vast') &&
				<div style={{width: '100%'}}>
				For video creatives set the size to 1x1<br/>
				Test your VAST tag <Link href="https://googleads.github.io/googleads-ima-html5/vsi/" target='blank'>here...</Link>
				<br/>
				<TextInput multiline source="markup" label="VAST XML"
				style={{ width: '50%' }} />
				</div>
			}
			</FormDataConsumer>
			<FormDataConsumer style={{width: '100%'}}>
			{({ formData, ...rest }) => (formData && formData.ctype == 'native') &&
				<div style={{width: '100%'}}>
				<TextInput source="sponsor" label='Sponsored By message should be the brand name of the sponsor. Recomanded 20 characters.' style={{width: '50%'}} />
				<br/>
				<TextInput source="title" label='Creative title and image "alt" Tag. Recomanded 60 characters.' style={{width: '50%'}} />
				<br/>
				<TextInput source="description" label='Product description. Recomanded 250 characters.' style={{width: '50%'}} />
				<br/>
				<TextInput source="call_to_action_button_text" label='Call to action button text. Recomanded 15 characters.' style={{width: '50%'}} />
				<br/>
				<TextInput source="click_url" type='url' label='Click Through URL *' style={{width: '50%'}}/>
				<br/>
				<ArrayInput source="impression_trackers">
					<SimpleFormIterator>
						<TextInput fullWidth />
					</SimpleFormIterator>
				</ArrayInput>
				<br/><br/>
				<ArrayInput source="click_trackers">
					<SimpleFormIterator>
						<TextInput fullWidth />
					</SimpleFormIterator>
				</ArrayInput>
				<br/><br/>
				<ImageInput label='Upload Image' accept='image/*' source="image">
				<ImageField source="src" title="title" />
				</ImageInput>
				</div>
			}
			</FormDataConsumer>
			<FormDataConsumer style={{width: '100%'}}>
			{({ formData }) => (formData && formData.ctype === 'image') &&
				<div style={{width: '100%'}}>
				<TextInput source="title" label='Image Title or HTML "alt" Tag' style={{width: '30%'}}/>
				<br/>
				<TextInput source="click_url" type='url' label='Click Through URL *' style={{width: '50%'}}/>
				<ImageInput label='Upload Image' accept='image/*' source="image">
				<ImageField source="src" title="title" />
				</ImageInput>
				</div>
			}
			</FormDataConsumer>

			<FormDataConsumer style={{width: '100%'}}>
			{({ formData }) => (formData && formData.ctype === 'html') &&
				<div style={{width: '100%'}}>
				<TextInput multiline source="markup" label="HTML Ad Markup" 
				style={{ width: '50%' }} 
				validate={validateHTML}/>
				</div>
			}
			</FormDataConsumer>

			<FormDataConsumer style={{width: '100%'}}>
			{({ formData }) => (formData && formData.ctype === 'url') &&
				<div style={{width: '100%'}}>
				<TextInput source="title" label='Image Title or HTML "alt" Tag' style={{width: '30%'}}/>
				<br/>
				<TextInput source="click_url" type='url' label='Click Through URL *' style={{width: '50%'}}/>
				<br/>
				<TextInput source="image_url" type='url' label='Image Full URL' style={{width: '50%'}}/>
				</div>
			}
			</FormDataConsumer>
			
		</FormTab>
		<FormTab label="Preview" icon={<VisibilityIcon />}>
			<FormDataConsumer>
			{({ formData }) => (
				<Box style={{ padding: '16px 0', width: '100%' }}>
					<CreativePreviewContent formData={formData} />
				</Box>
			)}
			</FormDataConsumer>
		</FormTab>
		</TabbedForm>
	</Edit>
);

export const CreativeCreate = ({ permissions, ...props }) => (
	<Create title="Create Creative" {...props}>
		<TabbedForm toolbar={<CustomToolbar {...props} {...permissions}/>} redirect='list'>
		<FormTab label="Creative Settings">
			<TextField source="code" label="Creative ID" />
			<TextInput source="name" label="Creative Name" style={{ width: '400px' }} validate={required()} />

			<ReferenceInput label="Advertiser *"
					perPage={15}
					sort={{ field: 'name', order: 'ASC' }}
					filterToQuery={searchText => ({ search_name: searchText })}
					source="advertiser_id"
					reference="advertisers"
					basePath='advertisers' defaultValue={101} >
					<AutocompleteInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""}
					optionValue='code' validate={required()} />
			</ReferenceInput>

			{/* <SelectInput label="Ad Size" source="adsize" validate={required()} choices={adsizeChoices} /> */}

			<NumberInput source="width" label="Creative Width" style={{ width: '400px' }} validate={required()} />
			<NumberInput source="height" label="Creative Height" style={{ width: '400px' }} validate={required()} />

			<ReferenceArrayInput source="iab_categories"
							reference="iab_categories"
							basePath='iab_categories'
							perPage={200}
							sort={{ field: 'name', order: 'DESC' }}
							filterToQuery={searchText => ({ search_name: searchText })}>
							<AutocompleteArrayInput label="IAB Categories" optionText="name" style={{ width: '90%' }} />
			</ReferenceArrayInput>

			{/* <SelectArrayInput label="Special Ad Categories" choices={specialCategories}
				source="special_categories" style={{ width: '400px' }}
          	/> */}

			{/* <BooleanInput source="backfill" label="Eligible for Backfill" resettable /> */}

			<FormDataConsumer>
			{({ formData }) => (formData && formData.backfill) &&
			<BooleanInput source="targeted" label="Creative Targeted" resettable />
			}
			</FormDataConsumer>

			<RadioButtonGroupInput style={{width: '100%'}} options={{row:true}} label="Creative Type" source="ctype" choices={ctypeChoices} />

			<FormDataConsumer style={{width: '100%'}}>
			{({ formData }) => (formData && formData.ctype === 'video') &&
				<div style={{width: '100%'}}>
				<TextInput source="video_url" label='Video file URL' style={{width: '30%'}}/>
				<br/>
				<TextInput source="video_click_url" type='url' label='Click Through URL *' style={{width: '50%'}}/>
				<br/>
				<NumberInput source="video_duration" label='Video duration in seconds. Keep it under 60...' style={{width: '30%'}}/>
				<br/>
				<SelectInput style={{width: '30%'}} label="Video Mime" source="video_mime" 
					choices={[
						{ id: 'video/mp4', name: 'video/mp4' }
					]}
				/>
				<br/>
				<TextInput source="video_impression_tracker" label='Video Impression Tracker' style={{width: '30%'}}/>
				</div>
			}
			</FormDataConsumer>
			<FormDataConsumer style={{width: '100%'}}>
			{({ formData }) => (formData && formData.ctype === 'vast') &&
				<div style={{width: '100%'}}>
				For video creatives set the size to 1x1<br/>
				Test your VAST tag <Link href="https://googleads.github.io/googleads-ima-html5/vsi/" target='blank'>here...</Link>
				<br/>
				<TextInput multiline source="markup" label="VAST XML"
				style={{ width: '50%' }} minRows={10}/>
				</div>
			}
			</FormDataConsumer>
			<FormDataConsumer style={{width: '100%'}}>
			{({ formData, ...rest }) => (formData && formData.ctype == 'native') &&
				<div style={{width: '100%'}}>
				<TextInput source="sponsor" label='Sponsored By message should be the brand name of the sponsor. Recomanded 20 characters.' style={{width: '50%'}} />
				<br/>
				<TextInput source="title" label='Creative title and image "alt" Tag. Recomanded 60 characters.' style={{width: '50%'}} />
				<br/>
				<TextInput source="description" label='Product description. Recomanded 250 characters.' style={{width: '50%'}} />
				<br/>
				<TextInput source="call_to_action_button_text" label='Call to action button text. Recomanded 15 characters.' style={{width: '50%'}} />
				<br/>
				<TextInput source="click_url" type='url' label='Click Through URL *' style={{width: '50%'}}/>
				<br/>
				<ArrayInput source="impression_trackers">
					<SimpleFormIterator>
						<TextInput fullWidth />
					</SimpleFormIterator>
				</ArrayInput>
				<br/><br/>
				<ArrayInput source="click_trackers">
					<SimpleFormIterator>
						<TextInput fullWidth />
					</SimpleFormIterator>
				</ArrayInput>
				<br/><br/>
				<ImageInput label='Upload Image' accept='image/*' source="image">
				<ImageField source="src" title="title" />
				</ImageInput>
				</div>
			}
			</FormDataConsumer>
			<FormDataConsumer style={{width: '100%'}}>
			{({ formData, ...rest }) => (formData && formData.ctype == 'image') &&
				<div style={{width: '100%'}}>
				<TextInput source="title" label='Image Title or HTML "alt" Tag' style={{width: '50%'}}/>
				<br/>
				<TextInput source="click_url" type='url' label='Click Through URL *' style={{width: '50%'}}/>
				<ImageInput label='Upload Image' accept='image/*' source="image">
				<ImageField source="src" title="title" />
				</ImageInput>
				</div>
			}
			</FormDataConsumer>
			<FormDataConsumer style={{width: '100%'}}>
			{({ formData, ...rest }) => (formData && formData.ctype == 'html') &&
				<div style={{width: '100%'}}>
				<TextInput multiline source="markup" label="HTML Ad Markup" 
				style={{ width: '50%' }} 
				validate={validateHTML}/>
				</div>
			}
			</FormDataConsumer>
			<FormDataConsumer style={{width: '100%'}}>
			{({ formData, ...rest }) => (formData && formData.ctype == 'url') &&
				<div style={{width: '100%'}}>
				<TextInput source="title" label='Image Title or HTML "alt" Tag' style={{width: '50%'}}/>
				<br/>
				<TextInput source="click_url" type='url' label='Click Through URL *' style={{width: '50%'}}/>
				<br/>
				<TextInput source="image_url" type='url' label='Image Full URL' style={{width: '50%'}}/>
				</div>
			}
			</FormDataConsumer>
		</FormTab>
		</TabbedForm>
	</Create>
);